module.exports = __webpack_public_path__ + "static/Bulette-25ddb35e501b4178edb39cb91f0203be.jpg";